import { merge } from "lodash-es";

import { isObject } from "../utils/utils.js";
import { createStore } from "./base.js";

const STORE = {
  currentAppId: "",
  context: {
    pageId: "",
    currentRoles: []
  },
  //Default values for variables,
  appVariablesDef: {},
  appVariables: {},
  storeInstances: {}
};

export const useBaseAppDevStore = createStore(
  "active_app_store",
  (setState, getState) => ({
    ...STORE,
    updatecurrentAppId: (appId) => {
      setState((state) => ({
        currentAppId: appId
      }));
    },
    updateStaticVariable: (variables) => {
      setState((state) => ({
        appVariablesDef: variables
      }));
    },

    getVariableDefinition: (key) => {
      let { allVariablesList } = getState().appVariablesDef;
      return allVariablesList.find((variable) => variable.Name === key);
    },
    resetState: () => {
      setState(() => ({
        currentAppId: "",
        appVariablesDef: {}
      }));
    },
    getVariable: (key) => {
      let value = getState().appVariables[key];
      if (value !== undefined || value !== null) {
        return value;
      } else {
        const appId = getState().currentAppId;
        let oldVariableStore = sessionStorage.getItem(appId)
          ? JSON.parse(sessionStorage.getItem(appId))
          : {};
        return oldVariableStore[key] ?? "";
      }
    },
    setVariable: (key, value) => {
      let newVariables = { ...getState().appVariables };
      newVariables[key] = value;
      sessionStorage.setItem(
        getState().currentAppId,
        JSON.stringify(newVariables)
      );
      setState((state) => ({
        appVariables: newVariables
      }));
      return {
        [key]: value
      };
    },
    updateVariables: (object) => {
      let newVariables = { ...getState().appVariables, ...object };
      sessionStorage.setItem(
        getState().currentAppId,
        JSON.stringify(newVariables)
      );
      setState((state) => ({
        appVariables: newVariables
      }));
      return object;
    },
    setAppContext: ({ appId, pageId, currentRoles }) => {
      setState((state) => ({
        currentAppId: appId,
        context: {
          appId,
          pageId,
          currentRoles
        }
      }));
    },
    updateCurrentPage: (pageId) => {
      setState((state) => ({
        context: {
          ...getState().context,
          pageId
        }
      }));
    },
    syncVariables: (appId, defaultValues, flushSessionValue = false) => {
      defaultValues = structuredClone(defaultValues);

      let sessionData = {};
      if (flushSessionValue) {
        // To reset the session storage value
        sessionStorage.setItem(appId, JSON.stringify(sessionData));
      } else {
        sessionData = JSON.parse(sessionStorage.getItem(appId)) || {};
      }

      let updatedVariables = { ...defaultValues };

      for (let variable in defaultValues) {
        let sessionValue = sessionData[variable];
        if (sessionValue) {
          updatedVariables[variable] = isObject(sessionValue)
            ? // Deep merge for json variable's newly added keys in development environment runtime
              merge(updatedVariables[variable], sessionValue)
            : sessionValue;
        }
      }

      setState((state) => ({
        appVariables: updatedVariables,
        currentAppId: appId
      }));
    },
    getWorkerInstance: (workerInstanceId) => {
      return getState().storeInstances?.[workerInstanceId];
    },
    setWorkerInstance: (workerInstanceId, workerInstance) => {
      setState((state) => ({
        storeInstances: {
          ...getState().storeInstances,
          [workerInstanceId]: workerInstance
        }
      }));
    }
  })
);
